const FILTER_STAGES = {
  MAIN: 'main',
  AIRLINES: 'airlines',
  TIME: 'time',
  TRANSFERS: 'transfers',
} as const;

export const filtersConfig = {
  FILTER_STAGES,
};

type FilterStageKey = keyof typeof FILTER_STAGES;
export type FilterStage = (typeof FILTER_STAGES)[FilterStageKey];
